export const actionTypes = {
    ADD_PUSH: "PUSH:ADD",
    DELETE_PUSH: "PUSH:DELETE",
    SET_SETTINGS: "PUSH:SET_SETTINGS"
}

export type pushType = {
    name: string;
    photo: string;
    text: string;
    id: number;
    mainPhotoVerifiedStatus: number
}